import type { Evaluation } from '@/types/overview';

export const getEvaluationLabel = ({
  value,
  editedEvaluation,
}: Evaluation): string =>
  editedEvaluation ? `${editedEvaluation.value} | ${value}` : value;
